import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Button, Alert } from 'react-bootstrap'
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { workStagesAPI } from '../../services/workStagesApi'
import SortableWorkStageRow from './SortableWorkStageRow'

const WorkStagesList = () => {
  const [workStages, setWorkStages] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  )

  useEffect(() => {
    loadWorkStages()
  }, [])

  const loadWorkStages = async () => {
    try {
      setLoading(true)
      const response = await workStagesAPI.getAll()
      setWorkStages(response.data)
    } catch (err) {
      setError('Ошибка загрузки этапов работ')
      console.error('Error loading work stages:', err)
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Вы уверены, что хотите удалить этап работ "${name}"?`)) {
      return
    }

    try {
      await workStagesAPI.delete(id)
      setWorkStages(workStages.filter(ws => ws.id !== id))
    } catch (err) {
      setError('Ошибка при удалении этапа работ')
      console.error('Error deleting work stage:', err)
    }
  }

  const handleDragEnd = async (event) => {
    const { active, over } = event

    if (!over || active.id === over.id) {
      return
    }

    const oldIndex = workStages.findIndex((ws) => ws.id === active.id)
    const newIndex = workStages.findIndex((ws) => ws.id === over.id)

    const newWorkStages = arrayMove(workStages, oldIndex, newIndex)
    setWorkStages(newWorkStages)

    try {
      const ids = newWorkStages.map((ws) => ws.id)
      await workStagesAPI.reorder(ids)
    } catch (err) {
      console.error('Error reordering work stages:', err)
      setWorkStages(workStages)
      setError('Ошибка при изменении порядка')
    }
  }

  if (loading) {
    return <div>Загрузка...</div>
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="mb-0">Прайсы</h1>
        <Link to="/work_stages/new" className="btn btn-primary btn-sm">
          Добавить этап работ
        </Link>
      </div>

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {workStages.length > 0 ? (
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <div className="table-responsive">
            <table className="table table-striped table-hover">
              <thead className="table-dark">
                <tr>
                  <th style={{ width: '30px' }}></th>
                  <th>№</th>
                  <th>Этап</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <SortableContext
                  items={workStages.map((ws) => ws.id)}
                  strategy={verticalListSortingStrategy}
                >
                  {workStages.map((workStage, index) => (
                    <SortableWorkStageRow
                      key={workStage.id}
                      workStage={workStage}
                      index={index}
                      onDelete={handleDelete}
                    />
                  ))}
                </SortableContext>
              </tbody>
            </table>
          </div>
        </DndContext>
      ) : (
        <p className="text-muted">
          Этапы работ пока не добавлены. Нажмите «Добавить этап работ» для создания первого этапа.
        </p>
      )}
    </div>
  )
}

export default WorkStagesList
